var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportStepThreeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.42,
    height: 18.59,
    viewBox: "0 0 22.42 18.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add_Group",
    "data-name": "Add Group",
    transform: "translate(-744.581 -690.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    transform: "translate(-159 363.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(903.581 335.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M19.135,231.365H16.941a3.274,3.274,0,0,0-.863.116,3.287,3.287,0,0,0-2.928-1.8H9.27a3.287,3.287,0,0,0-2.928,1.8,3.274,3.274,0,0,0-.863-.116H3.284A3.288,3.288,0,0,0,0,234.649v3.508a1.973,1.973,0,0,0,1.97,1.97H20.449a1.973,1.973,0,0,0,1.97-1.97v-3.508A3.288,3.288,0,0,0,19.135,231.365Zm-13.149,1.6v5.85H1.97a.658.658,0,0,1-.657-.657v-3.508a1.973,1.973,0,0,1,1.97-1.97H5.479a1.963,1.963,0,0,1,.515.069C5.989,232.819,5.986,232.891,5.986,232.964Zm9.134,5.85H7.3v-5.85a1.973,1.973,0,0,1,1.97-1.97h3.879a1.973,1.973,0,0,1,1.97,1.97Zm5.986-.657a.658.658,0,0,1-.657.657H16.433v-5.85c0-.073,0-.145-.008-.217a1.966,1.966,0,0,1,.515-.069h2.195a1.973,1.973,0,0,1,1.97,1.97Z",
    transform: "translate(0 -229.68)",
    fill: "#969fb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(905.044 330.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M36.332,126.5a2.918,2.918,0,1,0,2.918,2.918A2.922,2.922,0,0,0,36.332,126.5Zm0,4.523a1.6,1.6,0,1,1,1.6-1.6A1.606,1.606,0,0,1,36.332,131.027Z",
    transform: "translate(-33.414 -126.504)",
    fill: "#969fb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(910.892 327.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M170.861,43.729a3.9,3.9,0,1,0,3.9,3.9A3.9,3.9,0,0,0,170.861,43.729Zm0,6.484a2.585,2.585,0,1,1,2.585-2.585A2.588,2.588,0,0,1,170.861,50.213Z",
    transform: "translate(-166.962 -43.729)",
    fill: "#969fb1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(918.7 330.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M348.212,126.5a2.918,2.918,0,1,0,2.918,2.918A2.922,2.922,0,0,0,348.212,126.5Zm0,4.523a1.6,1.6,0,1,1,1.6-1.6A1.607,1.607,0,0,1,348.212,131.027Z",
    transform: "translate(-345.294 -126.504)",
    fill: "#969fb1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportStepThreeIcon);
export default __webpack_public_path__ + "static/media/import-step-three-icon.a19f17f3f30a41820a1c7290a53e3596.svg";
export { ForwardRef as ReactComponent };